import { Incident } from '@src/main/modules/other_incidents/domain/incident.model';
import { createOtherIncidentHttpRepository } from '@src/main/modules/other_incidents/infrastructure/OtherIncidentHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const sendIncidentColumbusUseCase = async (
  incidentId: string,
  tokenProvider: TokenProvider,
): Promise<Incident | null> => {
  const repository = createOtherIncidentHttpRepository(tokenProvider);
  const response = await repository.postColumbusIncident([incidentId]);
  return response?.[0] ?? null;
};
